import { useState } from 'react'
import ControlButton from 'ui/components/ControlButton'
import Select from 'ui/components/forms/Select/'
import ConfirmModal from 'ui/components/modals/ConfirmModal'
import { notifyError } from 'ui/components/Notify'
import UserStatusControl from 'ui/components/UserStatusControl'
import { SelectCol, SelectRow, SelectWrapper } from './styled'

export function SelectUser({
  users,
  userList,
  roleList,
  priceList,
  hasEstimate,
  updateProjectUserMutation,
  slug,
  canEditProjectUsers,
  activeManagersCount,
  changingUserId,
  onStatusChange,
}) {
  const getRoleDefaultValue = (role) => {
    const roleItem = role?.find(Boolean)

    if (!roleItem?.id) {
      return null
    }

    const label = roleItem.label || roleItem.name || ''

    return {
      id: roleItem.id,
      value: label,
      label,
    }
  }

  const getPriceRoleValue = (user) =>
    priceList.find((item) => item.id === user.pricelist_role_id) || null

  const roleChange = (value, user, priceValue = null) => {
    const currentRole = roleList.find((role) => value.id === role.id)

    if (!currentRole) {
      notifyError('Не обнаружена роль')
      return
    }

    updateProjectUserMutation({
      slug,
      userId: user.id,
      roleId: currentRole.id,
      priceId: priceValue?.id ?? null,
    })
  }

  return (
    <>
      {users?.map((user, index) => (
        <SelectRow key={user.id}>
          <SelectCol>
            <SelectWrapper>
              <Select
                label="Сотрудник"
                id={`nameSelect${index}`}
                required
                options={userList}
                placeholder="Сотрудник"
                maxHeight="200px"
                defaultValue={{
                  ...user,
                  label: user.name ? `${user.surname} ${user.name}` : '',
                }}
                isDisabled
              />
            </SelectWrapper>
          </SelectCol>

          <SelectCol>
            <Select
              placeholder="Роль"
              label="Роль"
              id={`roleSelect${index}`}
              required
              options={roleList}
              onChange={(value) => roleChange(value, user)}
              defaultValue={getRoleDefaultValue(user.role)}
              maxHeight="250px"
              isDisabled={!canEditProjectUsers}
            />
          </SelectCol>

          <SelectCol>
            <Select
              placeholder="Роль из сметы"
              label="Роль из сметы"
              id={`priceSelect${index}`}
              required={hasEstimate}
              options={priceList}
              onChange={(value) => roleChange(...user.role, user, value)}
              value={getPriceRoleValue(user, priceList)}
              maxHeight="250px"
              isDisabled={!canEditProjectUsers}
            />
          </SelectCol>

          {canEditProjectUsers && (
            <UserStatusControl
              user={user}
              activeManagersCount={activeManagersCount}
              isStatusChanging={changingUserId === user.id}
              onStatusChange={onStatusChange}
              marginBottom={14}
            />
          )}
        </SelectRow>
      ))}
    </>
  )
}
